export default {
    bank_id: '',
    bank_desc: '',
  };
  